import calcConsts from "../plugins/calcConsts";

export const getFeeTypeName = (id)=>{
  return calcConsts.feeType.find(item=>item.id === id).name
}
